<script>
export default {
    name: 'CardSecurity'
}
</script>
<template>
    <div
        class="divide-y divide-gray-200 overflow-hidden rounded-lg bg-gray-200 shadow sm:grid sm:grid-cols-1 sm:gap-px sm:divide-y-0 mt-3">
        <div
            class="flex items-center rounded-tl-lg rounded-tr-lg sm:rounded-tr-none relative group bg-white p-2 focus-within:ring-2 focus-within:ring-inset focus-within:ring-indigo-500">
            <div class="py-5 px-3">
                <span class="rounded-lg inline-flex p-3 bg-teal-50 text-teal-700 ring-4 ring-white">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                        stroke="currentColor" class="w-6 h-6">
                        <path stroke-linecap="round" stroke-linejoin="round"
                            d="M3.98 8.223A10.477 10.477 0 001.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.45 10.45 0 0112 4.5c4.756 0 8.773 3.162 10.065 7.498a10.523 10.523 0 01-4.293 5.774M6.228 6.228L3 3m3.228 3.228l3.65 3.65m7.894 7.894L21 21m-3.228-3.228l-3.65-3.65m0 0a3 3 0 10-4.243-4.243m4.242 4.242L9.88 9.88" />
                    </svg>
                </span>
            </div>
            <div class="p-1">
                <h3 class="text-md font-medium leading-none">
                    <span class="absolute inset-0" aria-hidden="true"></span>
                    Dados protegidos
                </h3>
                <p class="mt-2 text-sm text-gray-500">Os seus dados são confidenciais e seguros.</p>
            </div>
        </div>
        <div
            class="flex items-center relative group bg-white p-2 focus-within:ring-2 focus-within:ring-inset focus-within:ring-indigo-500">
            <div class="p-3">
                <span class="rounded-lg inline-flex p-3 bg-teal-50 text-teal-700 ring-4 ring-white">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                        stroke="currentColor" class="w-6 h-6">
                        <path stroke-linecap="round" stroke-linejoin="round"
                            d="M16.5 10.5V6.75a4.5 4.5 0 10-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 002.25-2.25v-6.75a2.25 2.25 0 00-2.25-2.25H6.75a2.25 2.25 0 00-2.25 2.25v6.75a2.25 2.25 0 002.25 2.25z" />
                    </svg>

                </span>
            </div>
            <div class="p-1">
                <h3 class="text-md font-medium leading-none">
                    <span class="absolute inset-0" aria-hidden="true"></span>
                    Pagamento 100% Seguro
                </h3>
                <p class="mt-2 text-sm text-gray-500">As informações desta compra são criptografadas.</p>
            </div>
        </div>
        <div
            class="flex items-center relative group bg-white p-2 focus-within:ring-2 focus-within:ring-inset focus-within:ring-indigo-500">
            <div class="p-3">
                <span class="rounded-lg inline-flex p-3 bg-teal-50 text-teal-700 ring-4 ring-white">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                        stroke="currentColor" class="w-6 h-6">
                        <path stroke-linecap="round" stroke-linejoin="round"
                            d="M9 12.75L11.25 15 15 9.75m-3-7.036A11.959 11.959 0 013.598 6 11.99 11.99 0 003 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.285z" />
                    </svg>
                </span>
            </div>
            <div class="p-1">
                <h3 class="text-md font-medium leading-none">
                    <span class="absolute inset-0" aria-hidden="true"></span>
                    Garantia de 7 dias
                </h3>
                <p class="mt-2 text-sm text-gray-500">Você esta protegido por uma garantia de satisfação</p>
            </div>
        </div>
    </div>
</template>
